import { ApiError } from "@tilt/admin-sdk";

/**
 * Pull the human-readable error message from whatever the caller
 * gave us. The admin-api returns `{ error, detail }` on 4xx/5xx -
 * `detail` is the friendly string, `error` is the code. Without this
 * helper, React Query's `err.message` becomes "API 409" with no
 * actionable context.
 *
 *   onError: (err) => setError(describe(err))
 *
 * Falls back to:
 *   - ApiError.body.detail (string)
 *   - ApiError.body.error (string)
 *   - err.message (for plain Error)
 *   - String(err) (last resort)
 */
export function describe(err: unknown): string {
  if (err instanceof ApiError && typeof err.body === "object" && err.body !== null) {
    const detail = (err.body as { detail?: unknown }).detail;
    if (typeof detail === "string" && detail) return detail;
    const error = (err.body as { error?: unknown }).error;
    if (typeof error === "string" && error) return error;
  }
  return err instanceof Error ? err.message : String(err);
}
